module.exports = __webpack_public_path__ + "static/media/email-icon-hover_1.93be4393.svg";